import React from "react"
import ImageList from "./imageList"
import NonImageList from "./nonImageList"

const MediaContentAdvanced = ({
  key,
  type="image",
  heading=null,
  content=null,
  mediaPosition="left",
  imageLink=null,
  openNewTab=null,
  image=null,
  imageList=null,
  buttons=null,
  video=null
}) => {
  return (
    <>
      <div className={ `advanced-media-with-content ${mediaPosition}` }>
        {type === 'imageList' &&
          <ImageList
            key={key}
            heading={heading}
            content={content}
            mediaPosition={mediaPosition}
            imageList={imageList}
            buttons={buttons}
          />
        }
        {type !== 'imageList' &&
          <NonImageList
            key={key}
            type={type}
            heading={heading}
            content={content}
            mediaPosition={mediaPosition}
            imageLink={imageLink}
            openNewTab={openNewTab}
            image={image}
            buttons={buttons}
            video={video}
          />
        }
      </div>
      {type === 'video' &&
      <>
        {video && video.videoSource &&
          <div className="modal fade content-video-modal" id={`video-${video.videoId}`} tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-body">
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                  </button>
                  <div className="embed-responsive embed-responsive-16by9">
                    {video.videoSource === 'youtube' &&
                      <iframe src={`https://www.youtube.com/embed/${video.videoId}`} title={heading} playing="true" height="720px" className="embed-responsive-item"/>
                    }
                    {video.videoSource === 'vimeo' &&
                      <iframe src={`https://player.vimeo.com/video/${video.videoId}`} title={heading} width="720" frameborder="0" allow="autoplay; fullscreen" allowfullscreen className="embed-responsive-item"/>
                    } 
                    {video.videoSource === 'wistia' &&
                      <iframe src={ `https://fast.wistia.net/embed/iframe/${video.videoId}` } allowtransparency="true" frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" allowfullscreen mozallowfullscreen webkitallowfullscreen oallowfullscreen msallowfullscreen width="720"/>
                    } 
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </>
      }
    </>
  )
}

export default MediaContentAdvanced
